import axios from "./instance";

const QcastApi = () => {
  const qcastQuery = async (userId, token, callback) => {
    try {
      const response = await axios({
        method: "get",
        url: "/getQcastByUser",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        params: {
          userId,
        },
      });
      callback(response.data);
    } catch (err) {
      callback({
        id: 500,
        msg: err.message,
      });
    }
  };

  const saveQcast = (qcastDetails, token, callback) => {
    const { userId, profileName, Status, title, tag } = qcastDetails;
    const formData = new FormData();

    Promise.all(
      qcastDetails.listOfVideo.map((vid) => {
        return getMeidaId(vid.file, "video/mp4", userId, token);
      })
    )
      .then((listOfId) => {
        let storeTempData = [];
        listOfId.forEach((data) => {
          if (data.id === 200) {
            storeTempData.push(data.data);
          } else {
            throw new Error(data.msg);
          }
        });

        formData.append("listOfVideo", storeTempData.join(","));

        if (qcastDetails.preview_video_id) {
          return getMeidaId(
            qcastDetails.preview_video_id,
            "video/mp4",
            userId,
            token
          );
        } else {
          return {
            id: 200,
            data: "",
            msg: "Empty",
          };
        }
      })
      .then((previewId) => {
        if (previewId.id === 200) {
          formData.append("preview_video_id", previewId.data);
        } else {
          throw new Error(previewId.msg);
        }

        if (qcastDetails.outrVideo) {
          return getMeidaId(qcastDetails.outrVideo, "video/mp4", userId, token);
        } else {
          return {
            id: 200,
            data: "",
            msg: "Empty",
          };
        }
      })
      .then((outrId) => {
        if (outrId.id === 200) {
          formData.append("outrVideo", outrId.data);
        } else {
          throw new Error(outrId.msg);
        }

        if (qcastDetails.cover_photo) {
          return getMeidaId(
            qcastDetails.cover_photo,
            "image/png",
            userId,
            token
          );
        } else {
          let storetemp = formData.get("listOfVideo").split(",")[0];
          console.log(storetemp);
          return {
            id: 200,
            data: storetemp,
            msg: "Operation success",
          };
        }
      })
      .then((coverId) => {
        if (coverId.id === 200) {
          formData.append("cover_photo", coverId.data);
        } else {
          throw new Error(coverId.msg);
        }

        formData.append("title", title);
        formData.append("tag", tag);
        formData.append("profileName", profileName);
        formData.append("Status", Status);
        formData.append("userId", userId);

        return axios({
          method: "post",
          url: "/addQcast",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        });
      })
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        callback({
          id: 500,
          msg: err.message,
        });
      });
  };

  function urltoFile(url, mimeType) {
    if (mimeType.split("/")[0] === "video") {
      return new Promise((resolve) => {
        let createdFile = new File([url], "qcast.mp4", { type: mimeType });
        resolve(createdFile);
      });
    } else if (mimeType.split("/")[0] === "image") {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(function (buf) {
          return new File([buf], "qcast.png", { type: mimeType });
        });
    }
  }

  const getMeidaId = async (file, mimeType, userId, token) => {
    try {
      const myFile = await urltoFile(file, mimeType);
      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("mediaFile", myFile);

      const response = await axios({
        method: "post",
        url: "/uploadGetMediaID",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });

      return response.data;
    } catch (err) {
      throw new Error(err);
    }
  };

  const getQcastDeepCopy = async (userId, qcastId, token, callback) => {
    try {
      const response = await axios({
        method: "get",
        url: "/getQcastDeepCopy",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        params: {
          userId,
          qcastId,
        },
      });
      callback(response.data);
    } catch (err) {
      callback({
        id: 500,
        msg: err.message,
      });
    }
  };

  const saveResponse = (responseDetails, token, callback) => {
    const {
      userId,
      qcastId,
      response,
      questionList,
      title,
      tag,
      responseThumbnail,
      answerIndex,
    } = responseDetails;

    const requestBody = {
      userId,
      qcastId,
      title,
      tag: tag.join("|"),
      questionList: questionList.join(","),
      answerTimeIndex: answerIndex.length > 0 ? answerIndex.join(";") : null,
    };

    getMeidaId(response, "video/mp4", userId, token)
      .then((responseId) => {
        if (responseId.id === 200) {
          requestBody.ansVideoList = responseId.data;
        } else {
          throw new Error(responseId.msg);
        }

        if (responseThumbnail) {
          return getMeidaId(responseThumbnail, "video/mp4", userId, token);
        } else {
          return {
            id: 200,
            data: requestBody.ansVideoList,
            msg: "Operation success",
          };
        }
      })
      .then((responseThumbnailId) => {
        if (responseThumbnailId.id === 200) {
          requestBody.responseThumnail = responseThumbnailId.data;

          return axios({
            method: "post",
            url: "/saveQcastInterview",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
            data: requestBody,
          });
        } else {
          throw new Error(responseThumbnailId.msg);
        }
      })
      .then((res) => {
        callback(res.data);
      })
      .catch((err) => {
        callback({
          id: 500,
          msg: err.message,
        });
      });
  };

  const getResponseDeepCopy = async (userId, interviewId, token, callback) => {
    try {
      const response = await axios({
        method: "post",
        url: "/getQcastInterview",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        params: {
          userId,
          interviewId,
        },
      });
      callback(response.data);
    } catch (err) {
      callback({
        id: 500,
        msg: err.message,
      });
    }
  };

  return {
    qcastQuery,
    saveQcast,
    getQcastDeepCopy,
    saveResponse,
    getResponseDeepCopy,
  };
};

export default QcastApi;
